import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { provideHttpClient } from '@angular/common/http';
// import { TokensModule } from './app/tokens/tokens.module';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
// import { AppModule } from './app/app.module';
import { importProvidersFrom } from '@angular/core';
// import { appConfig } from './app/app.config';
import { AppModule } from './app/app.module';

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

// bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err))
// // bootstrapApplication(AppComponent, {
// //   providers: [provideHttpClient(), TokensModule],
// // }).catch((err) => console.error(err));
